import React from 'react';
import { Link } from 'react-router-dom';
import { PARTNER_COLORS } from '../constants';

export const PartnerHero = ({
  title,
  subtitle,
  heroImageUrl,
  primaryLabel,
  primaryHref,
  primaryMailto = false,
  secondaryLabel,
  secondaryTo,
}) => (
  <section className="relative overflow-hidden border-b border-[#E5E7EB] bg-[#0B1E33] w-full min-h-[320px] sm:min-h-[360px] md:min-h-0 md:aspect-[12/5] flex items-center">
    {heroImageUrl ? (
      <>
        <img src={heroImageUrl} alt="" className="absolute inset-0 w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-[#0B1E33]/60" />
      </>
    ) : (
      <div
        className="absolute inset-0 opacity-[0.35]"
        style={{
          background: `radial-gradient(ellipse 80% 60% at 50% -20%, ${PARTNER_COLORS.accent}22, transparent)`,
        }}
      />
    )}
    <div className="container-main relative z-10 py-12 md:py-16 max-w-4xl mx-auto text-center px-4 w-full">
      <p
        className="text-xs md:text-sm font-bold uppercase tracking-[0.2em] mb-4"
        style={{ color: heroImageUrl ? '#FF7A00' : PARTNER_COLORS.accent }}
      >
        ByggFynd Partner
      </p>
      <h1
        className="font-heading text-3xl md:text-5xl font-black leading-tight mb-6"
        style={{ color: heroImageUrl ? '#FFFFFF' : PARTNER_COLORS.navy }}
      >
        {title}
      </h1>
      <p
        className="text-lg md:text-xl leading-relaxed max-w-2xl mx-auto mb-10"
        style={{ color: heroImageUrl ? 'rgba(255,255,255,0.9)' : PARTNER_COLORS.textMuted }}
      >
        {subtitle}
      </p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        {primaryLabel && (
          primaryMailto ? (
            <a
              href={primaryHref}
              className="inline-flex items-center justify-center rounded-full px-8 py-3.5 text-base font-bold text-white shadow-lg transition-all hover:shadow-xl hover:-translate-y-0.5"
              style={{ backgroundColor: PARTNER_COLORS.accent }}
            >
              {primaryLabel}
            </a>
          ) : (
            <Link
              to={primaryHref}
              className="inline-flex items-center justify-center rounded-full px-8 py-3.5 text-base font-bold text-white shadow-lg transition-all hover:shadow-xl hover:-translate-y-0.5"
              style={{ backgroundColor: PARTNER_COLORS.accent }}
            >
              {primaryLabel}
            </Link>
          )
        )}
        {secondaryLabel && secondaryTo && (
          <Link
            to={secondaryTo}
            className="inline-flex items-center justify-center rounded-full px-8 py-3.5 text-base font-semibold border-2 transition-colors hover:bg-gray-50"
            style={{ borderColor: PARTNER_COLORS.border, color: PARTNER_COLORS.navy }}
          >
            {secondaryLabel}
          </Link>
        )}
      </div>
    </div>
  </section>
);
